// extracted by mini-css-extract-plugin
export default {"root":"product_root__pKpkO","buttonBlock":"product_buttonBlock__VTShP","sideBlock":"product_sideBlock__mpub9"};